import { ContactBook, User, Student, Post } from '@/plugins/api'
import alert from '@/plugins/alert'
import utils from '@/plugins/utils'

export default {
  namespaced: true,
  state: {
    contactBooks: [],
    student: null
  },
  actions: {
    async fetchContactBooks({ commit }, options) {
      try {
        commit('setContactBooks', await ContactBook.fetch(options))
      } catch (error) {
        alert.error(error)
      }
    },
    async createContactBook({ commit }, data) {
      try {
        const contactBook = await ContactBook.create(data)
        await Student.update(contactBook.student.id, {
          contactBookPhones: contactBook.phones,
          contactBookStatus: contactBook.status,
          contactBookApp: contactBook.isApp,
          contactBookSms: contactBook.isSms
        })
        commit('createContactBook', contactBook)
      } catch (e) {
        alert.error(e)
      }
    },
    async removeContactBook({ commit }, id) {
      await ContactBook.remove(id)
      commit('removeContactBook', id)
    },
    async updateContactBook({ commit }, { id, ...contact }) {
      const contactBook = await ContactBook.updateContact(id, contact)
      await Student.update(contactBook.student.id, {
        contactBookPhones: contactBook.phones,
        contactBookStatus: contactBook.status,
        contactBookApp: contactBook.isApp,
        contactBookSms: contactBook.isSms
      })
      commit('updateContactBook', contactBook)
      return contactBook
    },
    async createUser({ commit }, { student, password, role, staffId }) {
      const data = {
        student: student.id,
        username: student.code,
        username_indexing: student.code.substring(5),
        username_no: parseInt(student.code.substr(0, 5)),
        password: password,
        type: 'student',
        role,
        email: student.email ? student.email : `random${Date.now()}@quanlylop.com`,
        status: 'active'
      }

      const user = await User.create(data)

      const content = `Tai khoan dang nhap APP so lien lac dien tu cua hoc sinh ${student.name}, Tai khoan: ${user.username}, mat khau: ${password}`
      const post = {
        student: student.id,
        senderMethod: 'sms',
        type: 'other',
        content,
        keywords: utils.clearUnicode(content),
        staff: staffId
      }
      await Post.create(post)

      return user
    },
    async removeUser({ commit }, id) {
      await User.remove(id)
    },
    async fetchStudent({ commit }, studentId) {
      commit('changeState', { student: null })
      const student = await Student.fetchOne(studentId)
      commit('changeState', { student })
    }
  },
  mutations: {
    setContactBooks(state, contactBooks) {
      state.contactBooks = contactBooks
    },
    updateContactBook(state, contact) {
      state.contactBooks = state.contactBooks.map(g => {
        if (contact.id === g.id) return contact
        else return g
      })
    },
    createContactBook(state, contact) {
      state.contactBooks = [contact, ...state.contactBooks]
    },
    removeContactBook(state, id) {
      state.contactBooks = state.contactBooks.filter(contact => contact.id !== id)
    }
  }
}
